let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j1Ceu")).then(() => parcelRequire('cc7Ln'));